import { Stack, Typography } from '@mui/material';
import { sentenceCase } from 'change-case';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { fDate } from '../../../utils/formatTime';
import { fCurrency } from '../../../utils/formatNumber';
import { getAssetDetail } from '../store/assetActions';
import { DetailField, DetailGrid } from '../../../components';

AssetDetailCard.propTypes = {
  recordId: PropTypes.string,
};

/** Only format when there is a value, so empty fields fall back to a dash. */
const asSentence = (value) => (value ? sentenceCase(value) : null);

export default function AssetDetailCard({ recordId }) {
  const dispatch = useDispatch();
  const { asset } = useSelector((state) => state.assetReducer);

  useEffect(() => {
    dispatch(getAssetDetail(recordId));
  }, [dispatch, recordId]);

  if (!asset || !Object.keys(asset).length) {
    return (
      <Stack sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Asset details will appear here
        </Typography>
      </Stack>
    );
  }

  return (
    <DetailGrid>
      <DetailField label="Name" value={asset?.name} />
      <DetailField label="Branch" value={asset?.branch?.name} />
      <DetailField label="Section" value={asset?.section} />
      <DetailField label="Category" value={asset?.asset_class} />
      {/* The API field is serial_no; this read serial_number, so it was always blank.
          A "Job Card Number" field was also shown here, but Asset has no such
          column (it lives on MaintenanceRecord), so it could never populate. */}
      <DetailField label="Serial Number" value={asset?.serial_no} />
      <DetailField label="Barcode Number" value={asset?.barcode_number} />
      <DetailField label="Purchase Date" value={asset?.purchase_date ? fDate(asset.purchase_date) : null} />
      <DetailField label="Purchase Cost" value={asset?.cost ? fCurrency(asset.cost) : null} />
      <DetailField label="Condition" value={asSentence(asset?.condition)} />
      <DetailField label="Status" value={asSentence(asset?.status)} />
      <DetailField label="Custodian" value={asset?.assigned_to?.user?.display_name} placeholder="Unassigned" />
      {asset?.has_warranty && <DetailField label="Warranty (Years)" value={asset?.warranty_value} />}
      <DetailField
        label="Description"
        value={asset?.description}
        multiline
        sx={{ gridColumn: { sm: '1 / -1' } }}
      />
    </DetailGrid>
  );
}
